import { render, staticRenderFns } from "./LoanEligibility.vue?vue&type=template&id=1820f621"
import script from "./LoanEligibility.vue?vue&type=script&lang=js"
export * from "./LoanEligibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports